module.exports = __webpack_public_path__ + "img/r.16b2ded2.svg";